var data = {
	"body": "<path d=\"M8 5.14v14l11-7l-11-7z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
